(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ez-review-preview"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = root => root.querySelectorAll('[data-ez-reviews]').forEach(section => {
  if(section.dataset.autoplayReady) return;
  section.dataset.autoplayReady='true';
  const track=section.querySelector('[data-ez-review-track]');
  const cards=[...track.querySelectorAll('.ez-review-card')];
  if(!cards.length)return;
  track.dataset.continuous='true';
  cards.forEach(card=>{const clone=card.cloneNode(true);clone.setAttribute('aria-hidden','true');clone.inert=true;clone.dataset.reviewClone='true';track.append(clone);});
  let paused=false,hovering=false,touchedUntil=0,last=0,position=track.scrollLeft;
  const step=()=>cards[0].getBoundingClientRect().width+(parseFloat(getComputedStyle(track).gap)||20);
  const advance=direction=>{
   touchedUntil=Date.now()+8000;
   track.scrollLeft=Math.max(0,track.scrollLeft+direction*step());
   position=track.scrollLeft;
  };
  section.querySelector('[data-ez-review-prev]').addEventListener('click',()=>advance(-1));
  section.querySelector('[data-ez-review-next]').addEventListener('click',()=>advance(1));
  const pause=section.querySelector('[data-ez-review-pause]');
  pause?.addEventListener('click',()=>{paused=!paused;pause.textContent=paused?'▶':'Ⅱ';pause.setAttribute('aria-label',paused?'Bewertungen automatisch abspielen':'Automatische Wiedergabe pausieren');pause.setAttribute('aria-pressed',String(paused));});
  section.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse')hovering=true;});
  section.addEventListener('pointerleave',()=>{hovering=false;});
  track.addEventListener('pointerdown',()=>{touchedUntil=Date.now()+8000;});
  track.addEventListener('wheel',()=>{touchedUntil=Date.now()+8000;},{passive:true});
  const frame=time=>{
   if(!section.isConnected)return;
   const elapsed=last?Math.min(time-last,50):0;last=time;
   const rect=section.getBoundingClientRect();
   if(paused||hovering||document.hidden||section.contains(document.activeElement)||Date.now()<touchedUntil||rect.bottom<=0||rect.top>=innerHeight){position=track.scrollLeft;}
   else {position+=elapsed*.032;const period=step()*cards.length;if(position>=period)position-=period;track.scrollLeft=position;}
   requestAnimationFrame(frame);
  };
  requestAnimationFrame(frame);
 });
 init(document);
 document.addEventListener('shopify:section:load',event=>init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
